import React, { FC, ReactNode, ReactElement, Children } from "react";
import { Grid, GridItem, GridItemProps } from "@UI/Components/Grid/Grid";
import useMediaQuery from "@UI/hooks/useMediaQuery";

interface Props {
  children: ReactNode;
}

export const SideBySideLeft: FC<GridItemProps> = (props) => (
  <GridItem {...props} />
);
export const SideBySideRight: FC<GridItemProps> = (props) => (
  <GridItem {...props} />
);
export const SideBySideDivider: FC<GridItemProps> = (props) => (
  <GridItem {...props} />
);

export const SideBySide: FC<Props> = ({ children }) => {
  const { isDesktop } = useMediaQuery();
  const slots = {
    left: undefined,
    right: undefined,
    divider: undefined,
  };

  Children.forEach(children, (child: ReactElement) => {
    if (child.type === SideBySideLeft) {
      slots.left = child;
    } else if (child.type === SideBySideRight) {
      slots.right = child;
    } else if (child.type === SideBySideDivider) {
      slots.divider = child;
    }
  });

  return (
    <Grid templateColumns={["1fr", "1fr", "1fr", "1fr 100px 1fr"]} gap={[3, 6]}>
      {slots.left}
      {isDesktop && slots.divider}
      {slots.right}
    </Grid>
  );
};
